{
  "name": "frontend",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "analyze": "ng build --stats-json",
    "build:branch": "ng build --configuration=branch",
    "build:prod": "ng build --configuration=production",
    "test": "jest",
    "test-watch": "jest --watch",
    "test-coverage": "jest --coverage",
    "test-ci": "jest --ci --coverage --maxWorkers=2",
    "i18n:keys": "transloco-keys-manager extract",
    "i18n:sync": "transloco-keys-manager extract --add-missing-keys --remove-extra-keys"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.16",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.16",
    "@angular/compiler": "^21.2.16",
    "@angular/core": "^21.2.16",
    "@angular/forms": "^21.2.16",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.16",
    "@angular/router": "^21.2.16",
    "@datx/core": "3.0.0",
    "@datx/jsonapi": "3.0.0",
    "@datx/jsonapi-angular": "3.0.0",
    "@datx/jsonapi-types": "3.0.0",
    "@datx/network": "3.0.0",
    "@datx/utils": "3.0.0",
    "@fontsource/roboto": "^5.3.0",
    "@jsverse/transloco": "^8.3.0",
    "@ngxs/devtools-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "@sentry/angular": "^10.57.0",
    "@wdidev/pixl-editor": "^0.0.108",
    "angular-split": "^20.0.0",
    "ngx-color-picker": "^20.1.1",
    "ngx-colors": "3.6.0",
    "rxjs": "7.8.2",
    "ts-md5": "1.3.1",
    "tslib": "^2.3.0",
    "turndown": "7.2.1",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-builders/jest": "^21.0.3",
    "@angular-devkit/build-angular": "^21.2.14",
    "@angular-devkit/core": "^21.2.14",
    "@angular-devkit/schematics": "^21.2.14",
    "@angular/build": "^21.2.14",
    "@angular/cli": "^21.2.14",
    "@angular/compiler-cli": "^21.2.16",
    "@angular/localize": "^21.2.16",
    "@angular/platform-browser-dynamic": "^21.2.16",
    "@eslint/js": "^10.0.1",
    "@jsverse/transloco-keys-manager": "^8.1.0",
    "@stylistic/eslint-plugin": "5.6.1",
    "@testing-library/angular": "^19.4.0",
    "@testing-library/dom": "10.4.1",
    "@testing-library/jest-dom": "6.9.1",
    "@types/jest": "^30.0.0",
    "@types/node": "24.10.1",
    "@types/turndown": "5.0.6",
    "@typescript-eslint/eslint-plugin": "^8.61.0",
    "@typescript-eslint/parser": "^8.61.0",
    "@typescript-eslint/utils": "^8.61.0",
    "angular-eslint": "21.4.0",
    "eslint": "^10.4.1",
    "jest": "^30.4.2",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^16.1.5",
    "jsdom": "^29.1.1",
    "msw": "2.12.3",
    "prettier": "^3.8.4",
    "source-map-explorer": "2.5.3",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.61.0"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
